<!--
 * @Author: Nie Wie
 * @Date: 2020-02-21 14:15:14
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-06-01 07:47:47
 * @Description: 观测时报---覆盖率-各省详细数据
 -->
<template>
  <div class="observe-cover-tb">
    <!-- <part-title title="中国数据"></part-title> -->
    <div class="observe-cover-tb__container" ref="table-con" v-if="coverageListUnion">
      <div v-show="showTitle" class="observe-cover-tb__over-title">
        <tr class="observe-cover-tb__header">
          <th v-for="item of columns" :key="item.index" :width="item.width">{{item.label}}</th>
        </tr></div>
      <table class="observe-cover-tb__table" rules=none >
        <!-- <tr>
          <td v-for="item of columns" :key="item.name" :width="item.width"></td>
        </tr> -->
        <tr class="observe-cover-tb__header">
          <th v-for="item of columns" :key="item.index" :width="item.width">{{item.label}}</th>
        </tr>
        <tr class="observe-cover-tb__tbody" v-for="item of coverageListUnion" :key="item.regionId">
          <template v-for="(col, colIndex) of columns" >
            <th v-if="colIndex === 0" :key="col.index">
              <span>{{getRegionName(item[col.name] || '-')}}</span>
            </th>

            <td v-else :key="col.index">
              <span>{{resetValue(item[col.name])}}</span>
            </td>
          </template>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

// import PartTitle from '@/components/part-title'

import {
  GET_STATISTICS,
} from '@/assets/const-value/interface'

moment.locale('fr', {
  week: {
    dow: 1, // 星期一是一周的第一天
    doy: 4, // 判断一年中的第一周
  },
})
const RegionDataList = []
export default {
  // components: {
  //   PartTitle,
  // },
  data() {
    return {
      regionWeekView: null,
      regionYearView: null,
      regionCover15: null,
      regionCover30: null,
      columns: [
        {
          class: 'observe-cover-tb__td',
          name: 'regionId',
          // name: 'regionName',
          label: '行政区',
          width: 140,
          index: 0,
        },
        {
          name: 'weekCount',
          label: '本周景数',
          width: 120,
          index: 1,
        },
        {
          name: 'yearCount',
          label: '本年景数',
          width: 140,
          index: 2,
        },
        {
          name: 'percent15',
          label: '近15天覆盖率',
          width: 140,
          index: 3,
        },
        {
          name: 'percent30',
          label: '近30天覆盖率',
          width: 140,
          index: 4,
        },
      ],
      coverageListUnion: [],
      showTitle: false,
    }
  },
  computed: {
    scroldddlTop() {
      const scrollTop = window.pageYOffset // 用于FF
          || document.documentElement.scrollTop
          || document.body.scrollTop
          || 0
      return scrollTop
    },
  },
  watch: {
    scroldddlTop: {
      deep: true,
      handler: () => {
        const a = this.$refs['table-con']
        if (a) {
          this.showTitle = window.scrollY - a.offsetTop > 0
        }
      },
    },
    regionWeekView(newVal) {
      this.unionList(newVal, 'weekCount')
    },
    regionYearView(newVal) {
      this.unionList(newVal, 'yearCount')
    },
    regionCover15(newVal) {
      this.unionList(newVal, 'percent15')
    },
    regionCover30(newVal) {
      this.unionList(newVal, 'percent30')
    },
  },
  created() {
    this.getStatistics()
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.handleScroll)
    })
  },
  methods: {
    handleScroll() {
      const dom = this.$refs['table-con']
      if (dom) {
        this.showTitle = window.scrollY - dom.offsetTop > 0
      }
    },
    getStatistics() {
      const year = moment().year()
      const periodType15 = 6 // month
      const periodType30 = 7 // month
      const period15 = '-' // moment().format('YYYYMMDD')
      const period30 = '-' // moment().format('YYYYMMDD')
      // const periodWeek8 = 8
      const periodWeek = 4
      const period = moment().format('YYYYww')
      const periodTypeYear = 1 // year
      const periodYear = moment().year()
      const typeAcquistion = 2 // 采集
      const typeUpload = 1 // cloud

      const satelliteGroupId6 = 6 // 可见光（计算覆盖率）
      const satelliteGroupId19 = 19 // 可见光（8个卫星的组）
      // 近15天上云覆盖率
      this.$axios.get(GET_STATISTICS({
        year, periodType: periodType15, period: period15, satelliteGroupId: satelliteGroupId6, type: typeAcquistion,
      })).then((res) => {
        if (res.code === 0) {
          const coverage = []
          res.data.children.forEach((region) => {
            const finder = coverage.find(i => i.regionId === region.regionId)
            if (finder) {
              finder.percent15 += (region.coveragePercentCurrent || 0).toFixed(2)
            } else {
              const obj = {
                regionId: region.regionId,
                percent15: (region.coveragePercentCurrent || 0).toFixed(2),
              }
              coverage.push(obj)
            }
          })
          this.regionCover15 = coverage
        }
      }).catch(err => console.log(err))

      // 近30天上云覆盖率
      this.$axios.get(GET_STATISTICS({
        year, periodType: periodType30, period: period30, satelliteGroupId: satelliteGroupId6, type: typeAcquistion,
      })).then((res) => {
        if (res.code === 0) {
          const coverage = []
          res.data.children.forEach((region) => {
            const finder = coverage.find(i => i.regionId === region.regionId)
            if (finder) {
              finder.percent30 += (region.coveragePercentCurrent || 0).toFixed(2)
            } else {
              const obj = {
                regionId: region.regionId,
                percent30: (region.coveragePercentCurrent || 0).toFixed(2),
              }
              coverage.push(obj)
            }
          })
          this.regionCover30 = coverage
        }
      }).catch(err => console.log(err))

      // 本周上云景数
      this.$axios.get(GET_STATISTICS({
        year, periodType: periodWeek, period, satelliteGroupId: satelliteGroupId19, type: typeUpload,
      })).then((res) => {
        if (res.code === 0 && res.data) {
        // if (res.code === 0) {
          const weekCount = []
          res.data.children.forEach((region) => {
            const obj = {
              regionId: region.regionId,
              weekCount: region.numCurrent,
            }
            weekCount.push(obj)
          })
          this.regionWeekView = weekCount
        }
      }).catch(err => console.error(err))

      // 本年上云景数
      this.$axios.get(GET_STATISTICS({
        year, periodType: periodTypeYear, period: periodYear, satelliteGroupId: satelliteGroupId6, type: typeAcquistion,
      })).then((res) => {
        if (res.code === 0) {
          const yearCount = []
          res.data.children.forEach((region) => {
            const obj = {
              regionId: region.regionId,
              yearCount: region.numCurrent,
            }
            yearCount.push(obj)
          })
          this.regionYearView = yearCount
        }
      }).catch(err => console.error(err))
    },
    unionList(list, key) {
      list.forEach((item) => {
        const finder = RegionDataList.find(i => i.regionId === item.regionId)
        if (finder) {
          finder[key] = item[key]
        } else {
          const obj = {
            regionId: item.regionId,
            [key]: item[key],
          }
          RegionDataList.push(obj)
        }
      })
      this.coverageListUnion = RegionDataList.filter(i => i.regionId !== '-').sort((a, b) => a.regionId - b.regionId)
      // if (Object.keys(RegionDataList[0]).length >= 5) {
      // }
    },
    getRegionName(regionId) {
      const china = {
        100000: '中国',
        110000: '北京',
        120000: '天津',
        130000: '河北',
        140000: '山西',
        150000: '内蒙古',
        210000: '辽宁',
        220000: '吉林',
        230000: '黑龙江',
        310000: '上海',
        320000: '江苏',
        330000: '浙江',
        340000: '安徽',
        350000: '福建',
        360000: '江西',
        370000: '山东',
        410000: '河南',
        420000: '湖北',
        430000: '湖南',
        440000: '广东',
        450000: '广西',
        460000: '海南',
        500000: '重庆',
        510000: '四川',
        520000: '贵州',
        530000: '云南',
        540000: '西藏',
        610000: '陕西',
        620000: '甘肃',
        630000: '青海',
        640000: '宁夏',
        650000: '新疆',
        710000: '台湾',
        810000: '香港',
        820000: '澳门',
      }
      return china[regionId]
    },
    resetValue(value) {
      if (value && value > 0.05) {
        return value
      }
      return '-'
    },
  },
}
</script>

<style lang="scss">
$fontSize: 24px;
$fontSizeBody: 28px;

.observe-cover-tb {
  padding: 0 35px;
}
.observe-cover-tb__over-title {
  position: fixed;
  top: 0;
  vertical-align: middle;
  padding-bottom: 10px;
  background: #fff;
}
.observe-cover-tb__table {
  border-collapse: separate;
  border-spacing: 0px 12px;
  font-family: PingFangSC-Regular,PingFang SC;
  font-weight: 400;
}
.observe-cover-tb__header {
  font-weight: 800;
  font-size: $fontSize;
  color: #737373;
  th,
  td {
    text-align: right;
    font-size: $fontSize;
    font-weight: 400;
  }
   th:nth-child(1){
    text-align: center;
  }

  th:nth-child(4) {
    padding-left: 20px;
    padding-right: 40px;
  }
  th:nth-child(5) {
    padding-right: 45px;
  }
}
.observe-cover-tb__tbody {
  margin: 6px 0;
  line-height: 80px;
  background: #F7F7F7;
  border-radius: 12px;
  font-size: $fontSizeBody;
  color: #222;
  th,
  td {
    text-align: center;
    font-weight: 400;
  }
  td {
    text-align: right;
  }

  th span {
    display: inline-block;
    width: $fontSizeBody * 3;
    text-align-last: justify;
    text-align: justify;
  }

  th {
    border-radius: 12px 0 0 12px;
  }

  td:nth-child(4) {
    padding: 0 30px;
  }
  td:nth-child(5) {
    padding-right: 40px;
    border-radius: 0 12px 12px 0;
  }
}
</style>
